import { Link } from 'react-router-dom';
import type { Platform } from '@/mocks/types';
import { articles } from '@/mocks/data';

interface PlatformCardProps {
  platform: Platform;
}

const colorMap = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', icon: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', icon: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', icon: 'text-secondary-600' },
};

export default function PlatformCard({ platform }: PlatformCardProps) {
  const colors = colorMap[platform.color];
  const relatedArticle = articles.find((a) => a.platform === platform.id);

  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colors.bg} ${colors.icon} flex-shrink-0`}>
          <i className={`${platform.icon} text-xl`}></i>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-foreground-900 mb-1">{platform.name}</h3>
          <div className="flex items-center gap-1 text-secondary-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <i
                key={i}
                className={`text-xs ${i < Math.floor(platform.rating) ? 'ri-star-fill' : 'ri-star-line'}`}
              ></i>
            ))}
            <span className="text-xs text-foreground-400 ml-1">{platform.rating}</span>
          </div>
        </div>
      </div>
      <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
        {platform.description}
      </p>
      <div className="flex flex-wrap gap-1.5 mb-4">
        {platform.features.map((feature) => (
          <span
            key={feature}
            className={`inline-flex px-2 py-0.5 rounded-full text-xs ${colors.bg} ${colors.text}`}
          >
            {feature}
          </span>
        ))}
      </div>
      {relatedArticle && (
        <Link
          to={`/article/${relatedArticle.id}`}
          className={`inline-flex items-center gap-1 text-sm font-medium ${colors.text} hover:underline cursor-pointer whitespace-nowrap`}
        >
          查看评测 <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      )}
    </div>
  );
}